export { AuctionTypeChangeEmailDialogComponent } from "./auction-type-change-email-dialog.component";



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail/auction-type-change-email-dialog/index.ts